import { AxiosError, AxiosResponse } from "axios";
import { SEARCH, USER_BASE, USER_Detail, CUSTOMER, AUTH_REFRESH, AUTH_INVALIDATE, USER_LOGIN_DETAILS_SAVE } from "../constant/api-constant";
import { IInvalidateTokenResponse, IRefreshTokenResponse, IUser, IUserDetail } from "../models/customer-model";
import { BaseApi } from "./base-axios";
import { defaultCommonSearch } from "../../interceptors/base-axios/base-axios";
import { CustomAxiosRequestConfig } from "../../interceptors/axios/custom-axios";
import { SESSION_REQUEST_CONFIG } from "../constant/constant";

export const getCustomerDetail = (customerId: number) =>
{
  return new Promise<IUser[]>((res, rej) =>
  {
    const pData = {
      ...defaultCommonSearch,
      customerId,
    };
    const url = `${ USER_BASE }/${ SEARCH }`;
    BaseApi.baseApiCon
      .post(url, { ...pData })
      .then((response: AxiosResponse) =>
      {
        res({ ...response.data } as IUser[]);
      })
      .catch((er: Error) =>
      {
        rej(
          new Error(
            //@ts-ignore
            (er as AxiosError).response?.data?.error?.errorMessage || er.message
          )
        );
      });
  });
};

export const getUserInfo = (userId: string) =>
{
  return new Promise<IUser[]>((res, rej) =>
  {
    const pData = {
      ...defaultCommonSearch,
      userId,
    };
    const url = `${ USER_BASE }/${ SEARCH }`;
    BaseApi.baseApiCon
      .post(url, { ...pData })
      .then((response: AxiosResponse) =>
      {
        res({ ...response.data } as IUser[]);
      })
      .catch((er: Error) =>
      {
        rej(
          new Error(
            //@ts-ignore
            (er as AxiosError).response?.data?.error?.errorMessage || er.message
          )
        );
      });
  });
};
    const storefrontId = 2;

export const getUserDetail = (honeywellOrEmailId: string) =>
{
  return new Promise<IUserDetail>((res, rej) =>
  {
    const url = `${ CUSTOMER }/${ USER_Detail }`;
    BaseApi.baseApiServiceCon
      .post(url, { honeywellOrEmailId, storeFrontId: storefrontId})
      .then((response: AxiosResponse) =>
      {
        res({ ...response.data.data } as IUserDetail);
      })
      .catch((er: Error) =>
      {
        const err = new Error(
          //@ts-ignore
          (er as AxiosError).response?.data?.error?.errorMessage || er.response?.data?.error?.errorDescription
        );
        rej(err);
      });
  });
};

export const refreshToken = () =>
{
  return new Promise<IRefreshTokenResponse>((res, rej) =>
  {
    const url = `${ AUTH_REFRESH }?storefrontName=INDS`;
    BaseApi.baseApiServiceCon
      .post(url, undefined, SESSION_REQUEST_CONFIG)
      .then((response: AxiosResponse) =>
      {
        res(response.data as IRefreshTokenResponse);
      })
      .catch((er: Error) =>
      {
        const err = new Error(
          //@ts-ignore
          (er as AxiosError).response?.data?.error?.errorMessage || er.message
        );
        rej(err);
      });
  });
};

export const invalidateToken = () =>
{
  return new Promise<IInvalidateTokenResponse>((res, rej) =>
  {
    const url = `${ AUTH_INVALIDATE }?storefrontName=INDS`;
    BaseApi.baseApiServiceCon
      .post(url, undefined, SESSION_REQUEST_CONFIG)
      .then((response: AxiosResponse) =>
      {
        res(response.data as IInvalidateTokenResponse);
      })
      .catch((er: Error) =>
      {
        const err = new Error(
          //@ts-ignore
          (er as AxiosError).response?.data?.error?.errorMessage || er.message
        );
        rej(err);
      });
  });
};

export const saveUserLoginDetails = (userId: string) =>
{
  return new Promise<void>((res, rej) =>
  {
    BaseApi.baseApiCon
      .post(USER_LOGIN_DETAILS_SAVE, { userId }, { requiresCSRF: true } as CustomAxiosRequestConfig)
      .then(() =>
      {
        res();
      })
      .catch((er: Error) =>
      {
        const err = new Error(
          //@ts-ignore
          (er as AxiosError).response?.data?.error?.errorMessage || er.message
        );
        rej(err);
      });
  });
};
